import { Component, Inject } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AdminService } from 'app/admin.service';
import { ApiService } from 'app/api.service';
import { CreateProductViewDialogComponent } from 'app/create-product-view-dialog/create-product-view-dialog.component';
import { FileShowModalComponent } from 'app/file-show-modal/file-show-modal.component';
import { ApprovalTimelineDialogComponent } from 'app/components/approval-timeline/approval-timeline-dialog.component';
import { UiPanelAction, UiPanelMode, UiApprovalStep } from 'app/shared/ui/models/ui-document-panel.model';
import { UiBadgeVariant } from 'app/shared/ui/models/ui-badge.model';
import { UI_DOCUMENT_PANEL_BREADCRUMBS } from 'app/shared/ui/document-panel/document-panel.config';

@Component({
  selector: 'app-credit-note-voucher',
  templateUrl: './credit-note-voucher.component.html',
  styleUrls: ['./credit-note-voucher.component.scss'],
  host: { class: 'ui-document-panel-host' },
})
export class CreditNoteVoucherComponent {
  panelMode: UiPanelMode = 'create';
  isView = false;
  readonly breadcrumb = UI_DOCUMENT_PANEL_BREADCRUMBS.creditNoteVoucher;
  existingFiles: any[] = [];
  productEntries: any[] = [];
  hostname: string;
  fullhostname: any;
  price_policy: number;
  company_cin: any;
  is_pi_si_manual: any;
  date: any;
  maxDate: string = '';
  myFiles: any[] = [];
  document_no: number = null;
  issue_date: any;
  uploadedFiles: any[] = [];
  narration: string;
  voucherType: any;
  voucher_data: any;
  voucher_type: any;
  vouchers: any[] = [];
  operationType: any;
  branch: any;
  branchdata: any = [];
  voucherNo: any;
  branch_access_list: any;
  type: any;
  unit_name: any;
  isUpdate: boolean = false;
  invoice_type: any;
  purchase_invoice: any[];
  sales_invoice: any[];
  credit_note: any[];
  debit_note: any[];
  purchaseInvoice: any;
  creditNote: any;
  salesInvoice: any;
  debitNote: any;
  profit_cost_id: any;
  profit_cost: any[] = [];
  invoice_date: any;
  is_affect_qty: any;
  sales_invoice_details: any[];
  debit_note_details: any[];
  credit_note_details: any[];
  purchase_invoice_details: any[];
  customers: any;
  cutomer_branchs: any;
  // customer_address1: any;
  // customer_district: any;
  // customer_pincode: any;
  // customer_city: any;
  customer: any;
  customer_name: string;
  customer_email: string;
  customer_phone: string;
  customer_address: string;
  //customer_gstno: string;
  customer_pan: string;
  company_name: string;
  company_email: string;
  company_phone: string;
  company_address: string;
  company_gstno: string;
  company_pan: string;
  company_logo: string;
  company_signature: string;
  customer_branch_gst: string;
  customer_branch_address: any;
  customer_branch_address1: any;
  customer_branch_city: any;
  customer_branch_pin_code: any;
  customer_branch_district: any;
  customer_branch_name: any;
  customer_branch_pincode: any;
  customer_branch_state: any;
  customerBranchLedger: any;
  cutomer_branch_ledger_id: any;
  cutomer_branch_ledger_name: any;
  vendorBranchLedger: any;
  vendor: any;
  vendors: any;
  vendor_branchs: any;
  vendor_name: string;
  vendor_email: string;
  vendor_phone: string;
  vendor_address: string;
  vendor_gstno: string;
  vendor_pan: string;
  vendor_branch_gst: any;
  vendor_branch_address: any;
  vendor_branch_address1: any;
  vendor_branch_city: any;
  vendor_branch_pin_code: any;
  vendor_branch_district: any;
  vendor_branch_name: any;
  vendor_branch_pincode: any;
  vendor_branch_email: any;
  vendor_branch_phone: any;
  vendorBranchGstType: any
  vendor_branch_ledger_id: any;
  vendor_branch_ledger_name: any;
  originalVoucherId: any;
  imageUrls: any[] = [];
  documentUrls: any[] = [];
  test: boolean = true;
  tax: any[] = [];
  documents: any[] = [];
  document: any;
  documentdetails: any[] = [];
  constructor(
    private apiService: ApiService,
    private adminService: AdminService,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<CreditNoteVoucherComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      voucherId: any;
      id?: number; voucherType: any;
      operationType: any; voucherNo: any; date: any; narration: any; debitSides: any[]; creditSides: any[]; upload: any;
      showInter: any;
      type?: any; branch_id?: any; profit_cost_id?: any; profit_costs?: any; store_id?: number; section_id?: any; originalVoucherId: null;
      isDuplicate: boolean;
      approval_status?: any;
      images: any;
      uploadedFiles: any;
      is_audit: any;
      layoutType?: string;
      selectedEmployees?: any[];
      voucherName?: any;
    }
  ) {
    console.log(this.data?.id, 'idddd')
    console.log(this.data?.voucherName, 'voucherName');
    let access_list = JSON.parse(localStorage.getItem("accesslist") || '{}');
    this.branch_access_list = access_list[0]?.branches;
    console.log(access_list, "access_list");
    console.log(this.branch_access_list, "branch_access_list");
    this.voucherType = data?.voucherType;
    console.log(this.voucherType, 'voucherType');

    this.fetchVoucherData();
    this.operationType = data?.operationType;
    console.log(this.operationType, 'operationType');
    this.initPanelMode();
    if (data?.type === 'update') {
      console.log('type', this.type);
      this.isUpdate = true;
    }
  }
  ngOnInit(): void {
    if (this.data.id) {
      this.fetchVoucherById();
    }
    this.hostname = window.location.hostname;
    this.fullhostname = window.location.origin;
    this.fetchcompany(this.hostname);
    const today = new Date();
    this.date = this.formatDate(today);
    this.maxDate = this.formatDate(today);
    this.fetchtaxData();
    if (!this.data.isDuplicate) return;
    this.voucherType = this.data.voucherType;
    this.voucherNo = null;
    this.date = this.data.date;
    this.branch = this.data.branch_id;
    this.profit_cost_id = this.data.profit_cost_id;
    this.uploadedFiles = this.data.upload || [];
    this.narration = this.data.narration;
    this.isUpdate = false;
    this.branchdata = (this.branchdata || []).map(b => ({ ...b, id: Number(b.id) }));

    if (this.data.uploadedFiles && this.data.uploadedFiles.length > 0) {
      this.myFiles = this.data.uploadedFiles.map(f => ({
        id: f.id,
        name: f.name,
        url: f.url,
        extension: f.extension,
        selected: false
      }));
    }
    // this.fetchtaxData();
  }
  fetchVoucherById() {
    console.log('inside fetch by id')
    console.log('Initial data.approval_status:', this.data?.approval_status);
    if (this.data?.id && (this.data?.voucherName === 'Credit Note')) {
      console.log('inside Credit Note')
      this.apiService.getvoucherPostingById(this.data.id).subscribe(
        (voucherData: any) => {
          console.log(voucherData, "data checcccck");
          console.log('Credit Note API approval_status:', voucherData?.Voucher?.approval_status);
          if (voucherData && voucherData.Voucher) {
            this.fetchbranchData();
            //this.fetchSalesInvoice();
            this.voucherType = voucherData.Voucher.voucher_id;
            this.voucherNo = voucherData.Voucher.voucher_no;
            this.date = voucherData.Voucher.date;
            this.branch = voucherData.Voucher.branch_id;
            if (voucherData.Voucher.sales_purchase_return_id) {
              console.log("1");
              this.invoice_type = 'sales'
              this.fetchSalesInvoice(voucherData.Voucher.sales_purchase_id, voucherData.Voucher.creation_voucher_details, voucherData.Voucher.sales_purchase_return_id);
            } else if (voucherData.Voucher.grn_gsn_id) {
              console.log("2");
              this.invoice_type = 'purchase'
              this.fetchPurchaseInvoice(voucherData.Voucher.sales_purchase_id, voucherData.Voucher.grn_gsn_id)
            }else {
              console.log("3");
              this.invoice_type = 'sales'
              this.fetchSalesInvoice(voucherData.Voucher.sales_purchase_id, voucherData.Voucher.creation_voucher_details, null);
            }
            this.narration = voucherData.Voucher.narration;
            const details = voucherData.Voucher?.creation_voucher_details || [];
            this.profit_cost_id = details.map((item: any) => item.profit_cost_id).filter((id: any) => id != null);
           if(this.profit_cost_id && (voucherData?.Voucher?.sales_purchase_return_id==null && voucherData?.Voucher?.grn_gsn_id==null)){
            console.log("4");
            this.fetchSalesInvoiceDetails(voucherData.Voucher.sales_purchase_id, voucherData.Voucher.creation_voucher_details);
           }
            this.type = voucherData.Voucher.calculation_type;
          }
        },
        (error) => {
          console.error("Error fetching ledger data:", error);
        }
      );
    }
  }
  formatDate(date: Date): string {
    return date.toISOString().split('T')[0];
  }
  fetchcompany(data: any) {
    this.apiService.Companydetails(data).subscribe(
      (response) => {
        console.log('company_details', response);
        this.company_name = response.name;
        this.company_email = response.email;
        this.company_phone = response.phone_no;
        this.company_address = response.address;
        this.company_gstno = response.gst_reg_no;
        this.company_pan = response.pan_no;
        this.company_cin = response.cin_no;
        this.company_logo = response.company_logo ? `${this.fullhostname}/api/storage/uploads/${response.company_logo}` : '';
        this.company_signature = response.company_signature ? `${this.fullhostname}/api/storage/uploads/${response.company_signature}` : '';
        this.price_policy = response.is_price_policy;
        this.is_pi_si_manual = response.is_pi_si_manual;
        console.log('is_pi_si_manual', this.is_pi_si_manual);
        console.log('company logo', this.company_logo);
        console.log('company signature', this.company_signature);
      },
      (error) => {
        console.error('Error fetching  companydata:', error);
      }
    );
  }
  getTitle(): string {
    return this.panelTitle;
  }
  getButton(): string {
    return this.data?.id ? 'Update' : 'Create';
  }

  get isInputDisabled(): boolean {
    return this.panelMode === 'view';
  }

  get activeLineItems(): any[] {
    if (this.invoice_type === 'sales') return this.sales_invoice_details || [];
    if (this.invoice_type === 'purchase') return this.debit_note_details || [];
    return [];
  }

  private initPanelMode(): void {
    const op = (this.operationType || this.data?.type || '').toString().toLowerCase();
    if (op === 'view') {
      this.panelMode = 'view';
      this.isView = true;
      this.isUpdate = true;
    } else if (op === 'update') {
      this.panelMode = 'edit';
      this.isView = false;
      this.isUpdate = true;
    } else {
      this.panelMode = 'create';
      this.isView = false;
      this.isUpdate = false;
    }
  }

  get panelTitle(): string {
    switch (this.panelMode) {
      case 'create': return 'Create Credit Note';
      case 'edit': return this.voucherNo ? `Edit Credit Note - ${this.voucherNo}` : 'Edit Credit Note';
      case 'view': return this.voucherNo ? `View Credit Note - ${this.voucherNo}` : 'View Credit Note';
      default: return 'Credit Note';
    }
  }

  get statusLabel(): string {
    if (!this.data?.id) return 'Draft';
    return this.data.approval_status || 'Open';
  }

  get statusVariant(): UiBadgeVariant {
    const status = this.data?.approval_status;
    if (!this.data?.id || status == null || status === 'Open') return 'default';
    if (status === 'Approved') return 'approved';
    if (status === 'Pending') return 'pending';
    if (status === 'Rejected') return 'rejected';
    return 'default';
  }

  get approvalSteps(): UiApprovalStep[] {
    const status = this.data?.approval_status;
    const steps: UiApprovalStep[] = [
      { id: 'draft', label: 'Draft', icon: 'edit_note', state: 'upcoming' },
      { id: 'pending', label: 'Pending Approval', icon: 'schedule', state: 'upcoming' },
      { id: 'approved', label: 'Approved', icon: 'check_circle', state: 'upcoming' },
    ];
    if (!this.data?.id) { steps[0].state = 'active'; return steps; }
    if (status == null || status === 'Open') steps[0].state = 'active';
    else if (status === 'Pending') { steps[0].state = 'completed'; steps[1].state = 'active'; }
    else if (status === 'Approved') { steps[0].state = 'completed'; steps[1].state = 'completed'; steps[2].state = 'completed'; }
    else if (status === 'Rejected') { steps[0].state = 'completed'; steps[1].state = 'rejected'; }
    return steps;
  }

  canEdit(): boolean {
    const status = this.data?.approval_status;
    return status == null || status === 'Open' || status === 'Rejected';
  }

  enterEditMode(): void {
    if (!this.canEdit()) return;
    this.panelMode = 'edit';
    this.isView = false;
    this.isUpdate = true;
    this.operationType = 'update';
  }

  onClose(): void {
    this.closeDialog();
  }

  onCancel(): void {
    this.closeDialog();
  }

  get footerPrimaryActions(): UiPanelAction[] {
    if (this.panelMode === 'view') {
      return this.canEdit()
        ? [{ id: 'edit', label: 'Edit', icon: 'edit', variant: 'primary', visible: true }]
        : [];
    }
    return [
      {
        id: 'save',
        label: this.getButton(),
        icon: 'save',
        variant: 'success',
        visible: this.data?.approval_status !== 'Pending' && this.data?.approval_status !== 'Approved',
      },
      {
        id: 'send-approval',
        label: 'Send For Approval',
        icon: 'send',
        variant: 'primary',
        visible: !!this.data?.id && this.canEdit(),
      },
    ];
  }

  get footerSecondaryActions(): UiPanelAction[] {
    return [
      {
        id: 'ledger-preview',
        label: 'View',
        icon: 'visibility',
        variant: 'outline',
        visible: this.panelMode !== 'view' && this.activeLineItems.length > 0,
      },
      {
        id: 'pdf',
        label: 'Download PDF',
        icon: 'picture_as_pdf',
        variant: 'outline',
        visible: this.panelMode !== 'view',
      },
      {
        id: 'timeline',
        label: 'Approval Timeline',
        icon: 'timeline',
        variant: 'outline',
        visible: !!this.data?.id &&
          ['Pending', 'Rejected', 'Approved'].includes(this.data.approval_status) &&
          this.panelMode !== 'view',
      },
      {
        id: 'cancel',
        label: this.panelMode === 'view' ? 'Close' : 'Cancel',
        icon: 'close',
        variant: 'outline',
        visible: true,
      },
    ];
  }

  get footerDestructiveAction(): UiPanelAction | null {
    return null;
  }

  get footerOverflowActions(): UiPanelAction[] {
    if (this.panelMode !== 'view' || !this.data?.id) return [];
    return [
      {
        id: 'timeline',
        label: 'Approval Timeline',
        icon: 'timeline',
        visible: ['Pending', 'Rejected', 'Approved'].includes(this.data.approval_status),
      },
      {
        id: 'pdf',
        label: 'Download PDF',
        icon: 'picture_as_pdf',
        visible: true,
      },
    ];
  }

  onFooterAction(actionId: string): void {
    switch (actionId) {
      case 'save':
        this.saveCreditNote();
        break;
      case 'send-approval':
        this.sendForApprove();
        break;
      case 'ledger-preview':
        if (this.invoice_type === 'sales') this.CreditNote();
        else this.DebitNote();
        break;
      case 'pdf':
        this.convertToPdf();
        break;
      case 'timeline':
        this.showApprovalTimeline();
        break;
      case 'edit':
        this.enterEditMode();
        break;
      case 'cancel':
      case 'close':
        this.onCancel();
        break;
    }
  }

  showApprovalTimeline(): void {
    if (!this.data?.id) return;
    const requestData = {
      document_type: 'Credit Note',
      document_id: this.data.id,
    };
    this.apiService.getApprovalTimeline(requestData).subscribe(
      (response) => {
        this.dialog.open(ApprovalTimelineDialogComponent, {
          width: '800px',
          height: '600px',
          disableClose: true,
          data: { approvalData: response.data || response },
        });
      },
      (error) => console.error('Error fetching approval timeline:', error)
    );
  }

  fetchVoucherData() {
    this.apiService.getDataVoucher().subscribe(
      (response) => {
        if (this.branch_access_list?.length == 1) {
          this.vouchers = response.filter(voucherType => voucherType.voucher_type !== 'Inter Branch');
        } else {
          console.log('else');
          this.vouchers = response.filter(voucherType => voucherType.voucher_type !== 'Purchase' && voucherType.voucher_type !== 'Sales');
        }
        if (this.voucherType) {
          this.fetchvouchertype(this.voucherType);
        }
      },
      (error) => {
        console.log("Error fetching data:", error);
      }
    );
  }
  fetchvouchertype(id: number): any {
    this.voucher_data = this.vouchers.find(item => item.id === id);
    this.voucher_type = this.voucher_data.voucher_type;
    this.fetchbranchData();
    console.log('voucher data', this.voucher_data);
    console.log('voucher type', this.voucher_type);
    // this.resetFields([
    //   'voucherType'
    // ]);
  }
  fetchbranchData() {
    this.apiService.getbranchData().subscribe(
      (response) => {
        this.branchdata = response;
        console.log('branchesss:', this.branchdata);
      },
      (error) => {
        console.error('Error fetching data:', error);
      }
    );
  }
  onBranchChangeWithLedger(branchId: any) {
    this.onInvoiceTypeChange();
  }
  fetchdocuments(sales_purchase_return_id: any,voucherData:any[] = []) {
    const postData = {
      voucher_type: this.voucher_type,
      invoice_type: this.invoice_type,
      invoice_id: this.purchaseInvoice ?? this.salesInvoice,
      branch_id: this.branch,
    };
    this.apiService.getDocumentData(postData).subscribe(
      (response) => {
        this.documents = response;
        console.log('documents', this.documents);
        if (sales_purchase_return_id) {
          this.document = sales_purchase_return_id;
          if (this.invoice_type == 'sales') {
            this.documentDetails(voucherData);
          } else {
            this.fetchGrnDetails();
          }
        }
      },
      (error) => {
        console.error('Error fetching documents:', error);
      }
    );
  }
  onInvoiceTypeChange() {
    console.log('invoice type', this.invoice_type);
    if (this.invoice_type === 'purchase') {
      this.fetchPurchaseInvoice();
    } else if (this.invoice_type === 'sales') {
      this.fetchSalesInvoice();
    }
  }
  fetchPurchaseInvoice(salesPurchaseId: any = null,  grn_gsn_id: any = null) {
    const postData = {
      Invoice_type: this.invoice_type,
      branch_id: this.branch
    };
    this.apiService.getPi(postData).subscribe(
      (response) => {
        this.purchase_invoice = response;
        console.log('purchase invoice', this.purchase_invoice);
        if (salesPurchaseId) {
          this.purchaseInvoice = salesPurchaseId;
          this.fetchProfitCostFromInvoice(this.invoice_type, this.purchaseInvoice);
          this.fetchdocuments(grn_gsn_id);
        }
      },
      (error) => {
        console.error('Error fetching voucher number:', error);
      }
    );

  }
  fetchSalesInvoice(salesPurchaseId: any = null, voucherData: any = null, sales_purchase_return_id: any = null) {
    const postData = {
      Invoice_type: this.invoice_type,
      branch_id: this.branch
    };
    this.apiService.getPi(postData).subscribe(
      (response) => {
        this.sales_invoice = response;
        console.log('sales invoice', this.sales_invoice);
        if (salesPurchaseId) {
          this.salesInvoice = salesPurchaseId;
          //this.fetchdocuments(sales_purchase_return_id,voucherData);
          this.fetchProfitCostFromInvoice(this.invoice_type, this.salesInvoice);
        }
         if (sales_purchase_return_id) {
           this.fetchdocuments(sales_purchase_return_id,voucherData);
         }
      },
      (error) => {
        console.error('Error fetching voucher number:', error);
      }
    );

  }

  onProfitCost(profitCostId: number | number[]) {
    if (this.invoice_type === 'purchase') {
       this.fetchGrnDetails();
    } else if (this.invoice_type === 'sales') {
      this.fetchSalesInvoiceDetails(this.salesInvoice);
    }
  }
  fetchSalesInvoiceDetails(Invoice_Id: number, savedDetails: any[] = []) {
    const data = {
      Invoice_Id: Invoice_Id,
      profit_cost_id: this.profit_cost_id
    }
    console.log("sales invoice details data",data);
    this.apiService.PostedVoucherdetails(data).subscribe(
      (response) => {
        console.log('sales invoice details', response);
        this.sales_invoice_details = response;
        this.customers = this.sales_invoice_details[0].customer_name;
        this.cutomer_branchs = this.sales_invoice_details[0].customer_branch_name;
        this.customer_branch_name = this.sales_invoice_details[0].customer_branch_name;
        //this.cutomer_branch_ledger_id = this.sales_invoice_details[0].customer_branch_ledger_id;
        //this.cutomer_branch_ledger_name = this.sales_invoice_details[0].customer_branch_ledger_name;
        this.customer_address = this.sales_invoice_details[0].customer_address;
        this.customer_email = this.sales_invoice_details[0].customer_email;
        this.customer_pan = this.sales_invoice_details[0].customer_pan;
        this.cutomer_branchs = this.sales_invoice_details[0].customer_branch_name;
        this.customer_branch_gst = this.sales_invoice_details[0].customer_branch_gst;
        this.customer_branch_address = this.sales_invoice_details[0].customer_branch_address;
        this.customer_branch_address1 = this.sales_invoice_details[0].customer_branch_address1;
        this.customer_branch_city = this.sales_invoice_details[0].customer_branch_city;
        this.customer_branch_district = this.sales_invoice_details[0].customer_branch_district;
        this.customer_branch_pincode = this.sales_invoice_details[0].customer_branch_pincode;
        this.customer_branch_state = this.sales_invoice_details[0].customer_branch_state;
        this.customer_phone = this.sales_invoice_details[0].customer_phone;
        this.unit_name = this.sales_invoice_details[0].unit_name;
        this.invoice_date = this.sales_invoice_details[0].sales_invoice_date;
        this.vendorBranchGstType = this.sales_invoice_details[0].customer_branch_gst_type;
        this.customerbranchledger(this.sales_invoice_details[0].customer_branch_id, this.branch);

        if(this.data.id){
          console.log('data id ');
          if (savedDetails && savedDetails.length > 0) {
            this.sales_invoice_details.forEach(item => {
              const match = savedDetails.find(d => d.grn_gsn_details_id === item.grn_gsn_details_id && d.product_id === item.product_id);
              if (match) {
                item.change_qty = match.qty;
                item.change_value = match.value;
                item.pending_qty = Number(item.pending_qty) + Number(match.qty);
                item.is_affect_qty = match.is_affect_qty;
              }
            });
            console.log('sales invoice details final', this.sales_invoice_details);
          }
      }else{
        console.log('data id else');
           if (this.documentdetails && this.documentdetails.length > 0) {
          this.sales_invoice_details.forEach(item => {
            const match = this.documentdetails.find((d: any) => d.purchase_voucher_details_id === item.id);
            if (match) {
              item.change_qty = match.change_qty;
              console.log("unit_price", item.unit_price);
              console.log("change_qty", match.change_qty);
              item.change_value = Number(match.change_qty) * Number(item.unit_price);
              console.log("change_value", item.change_value);
              item.is_affect_qty = 1;
              console.log("is_affect_qty", item.is_affect_qty);
              item.pending_qty = Number(item.pending_qty) + Number(match.change_qty);
              console.log("pending_qty", item.pending_qty);
            }
          });
        } 
      }

        console.log('customer', this.customers);
        console.log('customer branch', this.cutomer_branchs);
        console.log('sales invoice details', this.sales_invoice_details);
        // console.log('customer branch ledger', this.cutomer_branch_ledger_id);
        // console.log('customer branch ledger name ', this.cutomer_branch_ledger_name);
      },
      (error) => {
        console.error('Error fetching voucher number:', error);
      }
    );
  }

  fetchPurchaseInvoiceDetails(Invoice_Id: number, savedDetails: any[] = []) {
    const data = {
      Invoice_Id: Invoice_Id,
      profit_cost_id: this.profit_cost_id
    }
    this.apiService.PostedVoucherdetails(data).subscribe(
      (response) => {
        console.log('purchase invoice details', response);
        this.purchase_invoice_details = response;
        this.vendors = this.purchase_invoice_details[0].vendor_name;
        this.vendor_branchs = this.purchase_invoice_details[0].vendor_branch_name;
        this.vendor_branch_name = this.purchase_invoice_details[0].vendor_branch_name;
        //this.vendor_branch_ledger_id = this.purchase_invoice_details[0].vendor_branch_ledger_id;
        //this.vendor_branch_ledger_name = this.purchase_invoice_details[0].vendor_branch_ledger_name;
        this.vendor_address = this.purchase_invoice_details[0].vendor_address;
        this.vendor_email = this.purchase_invoice_details[0].vendor_email;
        this.vendor_pan = this.purchase_invoice_details[0].vendor_pan;
        this.vendor_phone = this.purchase_invoice_details[0].vendor_phone;
        //this.vendor_branchs = this.purchase_invoice_details[0].vendor_branch_name;
        this.vendor_branch_gst = this.purchase_invoice_details[0].vendor_branch_gst;
        this.vendor_branch_address = this.purchase_invoice_details[0].vendor_branch_address;
        this.vendor_branch_address1 = this.purchase_invoice_details[0].vendor_branch_address1;
        this.vendor_branch_city = this.purchase_invoice_details[0].vendor_branch_city;
        this.vendor_branch_district = this.purchase_invoice_details[0].vendor_branch_district;
        this.vendor_branch_pincode = this.purchase_invoice_details[0].vendor_branch_pincode;
        this.vendor_branch_email = this.purchase_invoice_details[0].vendor_branch_email;
        this.vendor_branch_phone = this.purchase_invoice_details[0].vendor_branch_phone;

        this.unit_name = this.purchase_invoice_details[0].unit_name;
        this.invoice_date = this.purchase_invoice_details[0].purchase_invoice_date;
        this.vendorBranchGstType = this.purchase_invoice_details[0].vendor_branch_gst_type;
        this.vendorbranchledger(this.purchase_invoice_details[0].vendor_branch_id, this.branch);
        if (savedDetails && savedDetails.length > 0) {
          this.purchase_invoice_details.forEach(item => {
            const match = savedDetails.find(d => d.grn_gsn_details_id === item.grn_gsn_details_id && d.product_id === item.product_id);
            if (match) {
              item.change_qty = match.qty;
              item.change_value = match.value;
              item.pending_qty = Number(item.pending_qty) + Number(match.qty);
            }
          });
          console.log('purchase invoice details final', this.purchase_invoice_details);
        }

        console.log('vendor', this.vendors);
        console.log('vendor branch', this.vendor_branchs);
        console.log('purchase invoice details', this.purchase_invoice_details);
        // console.log('vendor branch ledger', this.vendor_branch_ledger_id);
        // console.log('vendor branch ledger name ', this.vendor_branch_ledger_name);
      },
      (error) => {
        console.error('Error fetching voucher number:', error);
      }
    );
  }
 
  vendorbranchledger(vendor_branch_id, branch_id) {
    const postData = {
      vendor_branch_id: vendor_branch_id,
      branch_id: branch_id
    };
    this.apiService.getVendorBranchLedger(postData).subscribe(
      (response) => {
        this.vendorBranchLedger = response;
        console.log('vendor branch ledgers', this.vendorBranchLedger);
        this.vendor_branch_ledger_id = this.vendorBranchLedger[0].ledger_id;
        this.vendor_branch_ledger_name = this.vendorBranchLedger[0].ledger.ledger_name;
        console.log('vendor branch ledger', this.vendor_branch_ledger_id);
        console.log('vendor branch ledger name ', this.vendor_branch_ledger_name);
      },
      (error) => {
        console.error('Error fetching voucher number:', error);
      }
    );
  }
  customerbranchledger(customer_branch_id, branch_id) {
    const postData = {
      customer_branch_id: customer_branch_id,
      branch_id: branch_id
    };
    this.apiService.getCustomerBranchLedger(postData).subscribe(
      (response) => {
        this.customerBranchLedger = response;
        console.log('customer branch ledgerss', this.customerBranchLedger);
        this.cutomer_branch_ledger_id = this.customerBranchLedger[0].ledger_id;
        this.cutomer_branch_ledger_name = this.customerBranchLedger[0].ledger.ledger_name;
        console.log('customer branch ledger', this.cutomer_branch_ledger_id);
        console.log('customer branch ledger name ', this.cutomer_branch_ledger_name);
      },
      (error) => {
        console.error('Error fetching voucher number:', error);
      }
    );
  }

  fetchProfitCostFromInvoice(invoice_type: string, invoice_id: any) {
    const postData = {
      invoice_type: invoice_type,
      invoice_id: invoice_id
    };
    this.apiService.ProfitCostByInvoiceId(postData).subscribe(
      (response) => {
        console.log('profit cost', response);
        if (response) {
          this.profit_cost = response;
        }
      },
      (error) => {
        console.error('Error fetching profit cost:', error);
      }
    );
  }
 
  PriceChange(entry, qty, price) {
      if (price > ((entry.pending_qty) * (entry.unit_price))) {
        entry.change_value = '';
        entry.change_qty = '';
        entry.final_discount = '';
        entry.final_incentive = '';
        //alert('Change Value cannot be more than Value!');
        alert(`Change Value cannot be more than ${entry.pending_qty * entry.unit_price}`);
        return;
      } else if (price < 0) {
        entry.change_value = '';
        entry.change_qty = '';
        entry.final_discount = '';
        entry.final_incentive = '';
        alert('Change Value cannot be less than 0!');
        return;
      }
      entry.change_qty = parseFloat((price / entry.unit_price).toFixed(3));
      this.finaldiscount(entry);
      this.finalincentive(entry);
  };

  finaldiscount(entry) {
    if (entry.qty && entry.qty > 0) {
      if (entry.discount_amount) {
        entry.final_discount = parseFloat(((entry.discount_amount / entry.qty) * entry.change_qty).toFixed(2));
      }
    }
    return entry.final_discount;
  }

  finalincentive(entry) {
    if (entry.qty && entry.qty > 0) {
      if (entry.incentive_amount) {
        entry.final_incentive = parseFloat(((entry.incentive_amount / entry.qty) * entry.change_qty).toFixed(2));
      }
    }
    return entry.final_incentive;
  }
  gstMatch(): boolean {
    if (!Array.isArray(this.branchdata)) {
      return false;
    }
    const selectedBranch = this.branchdata.find(
      (branch: any) => branch.id === this.branch
    );
    const branchGstFirst2 = selectedBranch?.gst?.substring(0, 2);
    let otherBranchGstFirst2: string | undefined;
    if (this.invoice_type === 'purchase') {
      otherBranchGstFirst2 = this.vendor_branch_gst?.substring(0, 2);
      //console.log("otherBranchGstFirst2", otherBranchGstFirst2);
    } else if (this.invoice_type === 'sales') {
      otherBranchGstFirst2 = this.customer_branch_gst?.substring(0, 2);
      //console.log("otherBranchGstFirst2", otherBranchGstFirst2);
    }

    if (!branchGstFirst2 || !otherBranchGstFirst2) {
      // console.warn('GST number missing for one of the branches.');
      return false;
    }
    return branchGstFirst2 === otherBranchGstFirst2;
  }
  lineItemCgstAmount(detail: any) {
    if (!this.vendorBranchGstType || this.vendorBranchGstType === 'UNREGISTERED') return 'NA';
    if (this.vendorBranchGstType === 'SEZ' || this.vendorBranchGstType === 'COMPOSITE') return 0;
    if (this.vendorBranchGstType === 'REGISTER' && this.gstMatch()) {
      let value = 0;
      let qtyToUse = detail.qty || 0;
      if (this.voucher_type === 'Credit Note' && this.invoice_type === 'sales') {
        qtyToUse = detail.change_qty || 0;
        // console.log('qty', qtyToUse);
        // console.log('unit_price', detail.unit_price);
        // console.log('finaldiscount', this.finaldiscount(detail));
        // console.log('finalincentive', this.finalincentive(detail));
        value = (qtyToUse * (detail.unit_price || 0)) - (Number(detail?.final_discount) || 0) + (Number(detail?.final_incentive) || 0);
      } else if (this.voucher_type === 'Credit Note' && this.invoice_type === 'purchase') {
        value = (qtyToUse * (detail.unit_price || 0)) - (Number(detail?.discount_amount || 0)) + (Number(detail?.incentive_amount) || 0);
      }
      if (this.invoice_type) {
        const cgst = value * (detail.gst_percentage / 2) / 100;
        //console.log('cgst', cgst);
        return cgst
      }
    }
    return 0;
  }
  lineItemSgstAmount(detail: any) {
    if (!this.vendorBranchGstType || this.vendorBranchGstType === 'UNREGISTERED') return 'NA';
    if (this.vendorBranchGstType === 'SEZ' || this.vendorBranchGstType === 'COMPOSITE') return 0;
    if (this.vendorBranchGstType === 'REGISTER' && this.gstMatch()) {
      let value = 0;
      //const gstLedger = this.tax.find(item => item.global_gst_id === (detail.taxType || detail.gst_id));
      let qtyToUse = detail.qty || 0;
      if (this.voucher_type === 'Credit Note' && this.invoice_type === 'sales') {
        qtyToUse = detail.change_qty || 0;
        value = (qtyToUse * (detail.unit_price || 0)) - (Number(detail?.final_discount) || 0) + (Number(detail?.final_incentive) || 0);
      } else if (this.voucher_type === 'Credit Note' && this.invoice_type === 'purchase') {
        value = (qtyToUse * (detail.unit_price || 0)) - (Number(detail?.discount_amount || 0)) + (Number(detail?.incentive_amount) || 0);
      }
      if (this.invoice_type) {
        const sgst = value * (detail.gst_percentage / 2) / 100;
        return sgst
      }
    }
    return 0;
  }
  lineItemIgstAmount(detail: any) {
    if (!this.vendorBranchGstType || this.vendorBranchGstType === 'UNREGISTERED') return 'NA';
    if (this.vendorBranchGstType === 'SEZ' || this.vendorBranchGstType === 'COMPOSITE') return 0;
    if (this.vendorBranchGstType === 'REGISTER' && !this.gstMatch()) {
      let value = 0;
      let qtyToUse = detail.qty || 0;
      if (this.voucher_type === 'Credit Note' && this.invoice_type === 'sales') {
        qtyToUse = detail.change_qty || 0;
        value = (qtyToUse * (detail.unit_price || 0)) - (Number(detail?.final_discount) || 0) + (Number(detail?.final_incentive) || 0);
      } else if (this.voucher_type === 'Credit Note' && this.invoice_type === 'purchase') {
        value = (qtyToUse * (detail.unit_price || 0)) - (Number(detail?.discount_amount || 0)) + (Number(detail?.incentive_amount) || 0);
      } else {
        value = qtyToUse * (detail.unitPrice || detail.unit_price || 0);
      }
      if (this.invoice_type) {
        const igst = value * (detail.gst_percentage) / 100;
        return igst
      }
    }
    return 0;
  }

  lineItemTotalGstAmount(detail: any): any {
    if (!this.vendorBranchGstType || this.vendorBranchGstType === 'UNREGISTERED') return 'NA';
    if (this.vendorBranchGstType === 'SEZ' || this.vendorBranchGstType === 'COMPOSITE') return 0;
    const cgst = this.lineItemCgstAmount(detail);
    const sgst = this.lineItemSgstAmount(detail);
    const igst = this.lineItemIgstAmount(detail);
    let total = 0;
    if (cgst !== 'NA') total += Number(cgst) || 0;
    if (sgst !== 'NA') total += Number(sgst) || 0;
    if (igst !== 'NA') total += Number(igst) || 0;
    return total.toFixed(2);
  }
  getTotalGSTForDetails(details: any[]): number {
    if (!details) return 0;
    return details.reduce((total, detail) => {
      const gst = this.lineItemTotalGstAmount(detail);
      return total + (gst === 'NA' ? 0 : Number(gst) || 0);
    }, 0);
  }
  onFileSelected(event: any) {
    this.getFileDetails(event);
    // const files: FileList = event.target.files;
    // this.convertFileToBase64(files);
  }
  getFileDetails(e) {
    for (let i = 0; i < e.target.files?.length; i++) {
      const file = e.target.files[i];
      this.myFiles.push(file);
      const reader = new FileReader();
      reader.onload = (event: any) => {
        this.uploadedFiles.push({
          file: event.target.result,
          name: file.name,
          preview: event.target.result
        });
        console.log('Reader result:', event.target.result);
      };
      reader.readAsDataURL(file);
    }
  }
  removeFile(index: number) {
    this.myFiles.splice(index, 1);
  }
  openFileShowModal() {
    const finalId = this.data.id || this.originalVoucherId;

    if (finalId) {
      this.apiService.getImagesById(finalId, this.voucherType).subscribe(
        (data: any) => {

          this.imageUrls = [];
          this.documentUrls = [];

          data.imageUrls.forEach((file: any) => {
            if (this.isImage(file.extension)) {
              this.imageUrls.push(file);
            } else if (this.isDocument(file.extension)) {
              this.documentUrls.push(file);
            }
          });
        },
        error => {
          console.error("Error fetching images:", error);
        }
      );

      const modalRef = this.dialog.open(FileShowModalComponent, {
        width: "1200px",
        height: "600px",
        data: {
          id: finalId,                           // ⭐ Correct voucher ID
          name: this.test,
          voucherType: this.voucherType,
          is_audit: this.data.is_audit
        }
      });

    } else {
      console.error("No ID found for image loading!");
    }
  }

  isImage(extension: string): boolean {
    const imageExtensions = ['jpeg', 'jpg', 'png', 'svg', 'gif'];
    return imageExtensions.includes(extension.toLowerCase());
  }

  isDocument(extension: string): boolean {
    const documentExtensions = ['pdf', 'doc', 'docx', 'txt', 'xls', 'xlsx'];
    return documentExtensions.includes(extension.toLowerCase());
  }
  CreditNote() {
    let dialogData: any;
    let result = [];
    console.log("Final Data sales invoice details:", this.sales_invoice_details);
    const selectedVoucher = this.vouchers.find(voucher => voucher.id === this.voucherType);
    const selectedVoucherType = selectedVoucher?.voucher_type || '';

    if (this.invoice_type == 'sales') {
      result = this.sales_invoice_details
        .filter(item => item.change_qty && item.change_qty > 0)
        .map(item => ({
          product_ledger: item.product_ledger,
          product_ledger_name: item.product_ledger_name,
          product_name: item.name,
          change_qty: item.change_qty,
          change_value: (Number(item.change_value || 0) - Number(item?.final_discount || 0) + Number(item?.final_incentive || 0)),
          taxType: item.gst_id,
          invoice_id: item.invoice_id,
        }));
    } 
    // else {
    //   result = this.credit_note_details
    //     .filter(item => item.qty && item.qty > 0)
    //     .map(item => ({
    //       product_ledger: item.product_ledger,
    //       product_ledger_name: item.product_ledger_name,
    //       product_name: item.name,
    //       change_qty: item.qty,
    //       change_value: item.value - item.discount_amount + item.incentive_amount,
    //       taxType: item.gst_id,
    //       invoice_id: item.invoice_id,
    //     }));
    // }

    const groupedResult = new Map<number, any>();
    result.forEach(item => {
      const key = item.product_ledger;
      if (groupedResult.has(key)) {
        const existing = groupedResult.get(key);
        existing.change_qty = (Number(existing.change_qty) || 0) + (Number(item.change_qty) || 0);
        existing.change_value = (Number(existing.change_value) || 0) + (Number(item.change_value) || 0);
      } else {
        groupedResult.set(key, { ...item });
      }
    });
    const productarray = Array.from(groupedResult.values());

    const totalChangeValue = productarray.reduce(
      (sum, item) => sum + Number(item.change_value),
      0
    );
    console.log("Filtered Result sales invoice details:", result);
    dialogData = {
      branch_id: this.branch,
      productDetails: result,
      productarray: productarray,
      type: selectedVoucherType,
      CustomerBranchLedgerId: this.cutomer_branch_ledger_id,
      CustomerBranchLedgerName: this.cutomer_branch_ledger_name,
      CustomerAmount: totalChangeValue,
      InvoiceType: this.invoice_type,
      taxledger: this.tax,
      gstMatch: this.gstMatch(),
      //voucher: this.invoice_type === 'sales' ? 'Credit Note' : 'Debit Note',
      voucher: this.voucher_type
    };
    console.log("Dialog Data credit note details:", dialogData);
    this.dialog.open(CreateProductViewDialogComponent, {
      width: '1200px',
      height: '550px',
      data: dialogData
    });
  }
     DebitNote() {
      let dialogData: any;
      let result = [];
      console.log("Final Data purchase invoice details:", this.purchase_invoice_details);
      const selectedVoucher = this.vouchers.find(voucher => voucher.id === this.voucherType);
      const selectedVoucherType = selectedVoucher?.voucher_type || '';
        result = this.debit_note_details
          .filter(item => item.qty && item.qty > 0)
          .map(item => ({
            product_ledger: item.product_ledger,
            product_ledger_name: item.product_ledger_name,
            product_name:item.name,
            change_qty: item.qty,
            change_value: item.value,
            taxType: item.gst_id
          }));
  
      const groupedResult = new Map<number, any>();
      result.forEach(item => {
        const key = item.product_ledger;
        if (groupedResult.has(key)) {
          const existing = groupedResult.get(key);
          existing.change_qty = (Number(existing.change_qty) || 0) + (Number(item.change_qty) || 0);
          existing.change_value = (Number(existing.change_value) || 0) + (Number(item.change_value) || 0);
        } else {
          groupedResult.set(key, { ...item });
        }
      });
      const productarray = Array.from(groupedResult.values());
  
      const totalChangeValue = productarray.reduce(
        (sum, item) => sum + Number(item.change_value),
        0
      );
  
      console.log("Filtered Result:", result);
      dialogData = {
        branch_id: this.branch,
        productDetails: result,
        productarray: productarray,
        type: selectedVoucherType,
        VendorBranchLedgerId: this.vendor_branch_ledger_id,
        VendorBranchLedgerName: this.vendor_branch_ledger_name,
        VendorAmount: totalChangeValue,
        InvoiceType: this.invoice_type,
        taxledger: this.tax,
        gstMatch: this.gstMatch(),
        voucher: this.voucher_type
      };
      console.log("Dialog Data debit note details:", dialogData);
      this.dialog.open(CreateProductViewDialogComponent, {
        width: '1200px',
        height: '550px',
        data: dialogData
      });
    }

  saveCreditNote(isApproval: boolean = false) {
    let debitEntries: any[] = [];
    let creditEntries: any[] = [];
    let totalValue = 0;
    if (!this.voucherType) {
      alert('Please select a Voucher type');
      return;
    }
    if (!this.invoice_type) {
      alert('Please select a Invoice type');
      return;
    }
    if (!this.branch) {
      alert('Please select a Branch');
      return;
    }
    if (!this.profit_cost_id) {
      alert('Please select a Profit Cost Center');
      return;
    }
    if (!this.date) {
      alert('Please select a Date');
      return;
    }
    if (!this.narration) {
      alert('Please enter Narration Before Submiting');
      return;
    }
    if (this.invoice_type == 'sales') {
      const originalProductEntries = this.productEntries;
      this.productEntries = this.sales_invoice_details
        .filter(item => item.change_qty && item.change_qty > 0)
        .map(item => ({
          qty: 1,
          unitPrice: (Number(item.change_value || 0) - Number(item.final_discount || 0) + Number(item.final_incentive || 0)),
          discount: 0,
          taxType: item.gst_id
        }));
      const groupedGstDetails = this.getGroupedGstDetails();
      console.log("Grouped GST Details:", groupedGstDetails);
      this.productEntries = originalProductEntries;
      console.log("productEntries:", this.productEntries);
      debitEntries = this.sales_invoice_details
        .filter(item => item.change_qty && item.change_qty > 0)
        .map(item => ({
          ledger_id: item.product_ledger,
          amount: (Number(item.change_value || 0) - Number(item.final_discount || 0) + Number(item.final_incentive || 0)),
          description: '',
        }));
      console.log("Debit Entries 1:", debitEntries);
      groupedGstDetails.forEach(entry => {
        debitEntries.push({
          ledger_id: entry.ledger_id,
          amount: entry.totalAmount.toFixed(2),
          description: '',
        });
      });

      totalValue = debitEntries.reduce(
        (sum, item) => sum + Number(item.amount),
        0
      );
      console.log("Total Value:", totalValue);

      creditEntries = [{
        ledger_id: this.cutomer_branch_ledger_id,
        amount: totalValue,
        description: ''
      }];
      console.log("Credit Entries:", creditEntries);
    } else {
      const originalProductEntries = this.productEntries;
      this.productEntries = this.debit_note_details
        .filter(item => item.qty && item.qty > 0)
        .map(item => ({
          qty: 1,
          unitPrice: item.value - item.discount_amount + item.incentive_amount,
          discount: 0,
          taxType: item.gst_id
        }));
      const groupedGstDetails = this.getGroupedGstDetails();
      this.productEntries = originalProductEntries;

      debitEntries = this.debit_note_details
        .filter(item => item.qty && item.qty > 0)
        .map(item => ({
          ledger_id: item.product_ledger,
          amount: item.value - item.discount_amount + item.incentive_amount,
          description: '',
        }));

      groupedGstDetails.forEach(entry => {
        debitEntries.push({
          ledger_id: entry.ledger_id,
          amount: entry.totalAmount.toFixed(2),
          description: '',
        });
      });

      totalValue = debitEntries.reduce(
        (sum, item) => sum + Number(item.amount),
        0
      );

      creditEntries = [{
        ledger_id: this.vendor_branch_ledger_id,
        amount: totalValue,
        description: ''
      }];
    }

    const groupEntries = (entries: any[]) => {
      const groupedMap = new Map<number, any>();
      entries.forEach(entry => {
        const key = entry.ledger_id;
        if (groupedMap.has(key)) {
          const existing = groupedMap.get(key);
          existing.amount = (Number(existing.amount) || 0) + (Number(entry.amount) || 0);
        } else {
          groupedMap.set(key, { ...entry });
        }
      });
      return Array.from(groupedMap.values()).map(e => ({
        ...e,
        amount: Number(e.amount).toFixed(2)
      }));
    };

    const groupedDr = groupEntries(debitEntries);
    console.log("Grouped Debit Entries:", groupedDr);
    const groupedCr = groupEntries(creditEntries);
    console.log("Grouped Credit Entries:", groupedCr);
    const postData = {
      voucher_id: this.voucherType,
      voucher_no: this.voucherNo || null,
      date: this.date,
      narration: this.narration,
      doc_type: 'credit note',
      total_cr: totalValue,
      total_dr: totalValue,
      dr: groupedDr,
      cr: groupedCr,
      details: this.invoice_type == 'purchase' ? this.debit_note_details : this.sales_invoice_details,
      branch_id: this.branch ?? null,
      //upload: this.uploadedFiles,
      profit_cost_id: this.profit_cost_id,
      sales_purchase_id: this.salesInvoice || this.purchaseInvoice,
      document_id: this.document,
      calculation_type: this.type,
      existing_uploads: this.existingFiles,
      new_uploads: this.uploadedFiles,
      invoice_type: this.invoice_type,
    };
    console.log('final payload', postData);
    //return;
    if (this.data?.id) {
      this.apiService.updateVoucherPosting(this.data.id, postData).subscribe(
        response => {
          console.log('Voucher updated successfully:');
          if (isApproval) {
            this.sendForApprove(true);
          } else {
            this.dialogRef.close(response);
          }
        },
        error => {
          console.error('Error updating voucher:', error);
        }
      );
    } else {
      this.apiService.createVoucherPosting(postData).subscribe(
        response => {
          console.log('Voucher Posting successfully:');
          this.dialogRef.close(response);
        },
        error => {
          console.error('Error posting voucher:', error);
        }
      );
    }
  }

  fetchtaxData() {
    this.apiService.getGst().subscribe(
      (response) => {
        this.tax = response;
      },
      (error) => {
        console.error('Error fetching data:', error);
      }
    );
  }
  getGroupedGstDetails() {
    const groupedLedgers: { [key: number]: { ledger_id: number; totalAmount: number } } = {};
    console.log("productEntries", this.productEntries);
    this.productEntries.forEach((product: any) => {
      const gstDetailsArray = this.getGstLedgerDetails(product.taxType);
      console.log("gstDetailsArray", gstDetailsArray);
      gstDetailsArray.forEach(gstDetails => {
        const totalPrice = product.qty * product.unitPrice;
        //console.log("totalPrice", totalPrice);
        const discountAmount = product?.discount_amount || 0;
        //console.log("discountAmount", discountAmount);
        const incentiveAmount = product?.incentive_amount || 0;
        //console.log("incentiveAmount", incentiveAmount);
        const discountedPrice = totalPrice - discountAmount + incentiveAmount;
        //console.log("discountedPrice", discountedPrice);
        const gstAmount = (discountedPrice * gstDetails.gst_percentage) / 100;
        //console.log("gstAmount", gstAmount);
        if (groupedLedgers[gstDetails.ledger_id]) {
          groupedLedgers[gstDetails.ledger_id].totalAmount += gstAmount;
          console.log("if groupedLedgers", groupedLedgers);
        } else {
          groupedLedgers[gstDetails.ledger_id] = {
            ledger_id: gstDetails.ledger_id,
            totalAmount: gstAmount,
          };
          console.log("else groupedLedgers", groupedLedgers);
        }
      });
    });
    return Object.values(groupedLedgers);
  }
  getGstLedgerDetails(taxType: number): { ledger_id: number; gst_percentage: number }[] {
    const gstLedger = this.tax.find(item => item.global_gst_id === taxType);
    if (!gstLedger) return [];
    const requiredLedgerType =
      this.voucher_type === 'Purchase' || (this.invoice_type === 'purchase') ? 'receivable' : 'payable';
    const isSameState = this.gstMatch();
    console.log("requiredLedgerType", requiredLedgerType);
    console.log("this.invoice_type", this.invoice_type);
    console.log("Is Same State:", isSameState);
    console.log("GST Ledger:", gstLedger.gst_ledgers);
    let gstLedgers = gstLedger.gst_ledgers.filter(
      ledger => ledger.ledger_type === requiredLedgerType && (!ledger.branch_id || ledger.branch_id == this.branch)
    );
    console.log("after filter GST Ledgers:", gstLedgers);
    if (isSameState) {
      return gstLedgers
        .filter(l => l.gst_type === 'CGST' || l.gst_type === 'SGST')
        .map(l => ({
          ledger_id: l.ledger.id,
          gst_percentage: gstLedger.gst_percentage / 2
        }));
    } else {
      return gstLedgers
        .filter(l => l.gst_type === 'IGST')
        .map(l => ({
          ledger_id: l.ledger.id,
          gst_percentage: gstLedger.gst_percentage
        }));
    }

  }
  sendForApprove(skipSave: boolean = false) {
    if (!skipSave && this.data.id) {
      if (this.voucher_type === 'Credit Note') {
        this.saveCreditNote(true);
      } else if (this.voucher_type === 'Debit Note') {
        //this.saveDebitNote(true);
      }
      // else {
      //   this.onSave(true);
      // }
      return;
    }

    console.log(this.data);
    let document_type = '';
    if (this.invoice_type == 'purchase') {
      document_type = 'Purchase Voucher';
    } else{
      document_type = 'Salesvoucher';
    } 
    const requestData = {
      document_type: document_type,
      document_id: this.data.id,
      // profit_cost_id: this.profit_cost_id,
    };

    this.apiService.sendForApproval(requestData).subscribe(
      (approvalResponse) => {
        console.log('Voucher posting sent for approval:', approvalResponse);
        alert('Document sent for approval');
        this.dialogRef.close({ data: this.data.id, action: 'approvalsend' });
      },
      (approvalError) => {
        console.error('Error sending voucher posting for approval:', approvalError);
        alert('Error sending voucher posting for approval: ' + (approvalError.error?.message || approvalError.message || 'Unknown error'));
      }
    );
  }

  convertToPdf(copyKey: 'original' | 'duplicate' | 'extra' = 'original') {
    try {
      let itemdetails = this.productEntries || [];
      let resultArray: any[] = [];
      let totalSum = 0;
      let totalbefortax = 0, totaldiscount = 0, totalafterdiscount = 0, totaltax = 0, roundedamount = 0, totalamount = 0;
      //  let so_no = '';
      let doc_no = '';
      let so_date = '';
      let start_date = '';
      let end_date = '';
      let categoryName = '';
      let so_no = '';
      let po_no = '';
      let sales_invoice_date = '';
      let purchase_invoice_date = '';
      let si_no = '';
      let pi_no = '';
      let credit_note_date = '';
      let debit_note_date = '';
      const selectedVoucher = this.vouchers.find(voucher => voucher.id === this.voucherType);
      const isPurchase = selectedVoucher?.voucher_type === 'Purchase';
      const isSales = selectedVoucher?.voucher_type === 'Sales';
      const isCreditNote = selectedVoucher?.voucher_type === 'Credit Note';
      const isDebitNote = selectedVoucher?.voucher_type === 'Debit Note';
      const invoiceType = this.invoice_type;
      console.log('invoiceType', invoiceType);
      const selectedBranch = this.branchdata.find(
        (branch: any) => branch.id === this.branch
      );
      const branch_gst = selectedBranch?.gst;
      console.log('branchess', branch_gst);
      const branch_billing_address = selectedBranch?.billing_address ?? '';
      const branch_billing_phone = selectedBranch?.billing_phone ?? '';
      const branch_billing_phone1 = selectedBranch?.billing_phone1 ?? '';
      const branch_email = selectedBranch?.billing_email ?? '';
      const branch_fax = selectedBranch?.billing_fax ?? '';
      const branch_website = selectedBranch?.billing_website ?? '';
      console.log("Selected Branch Full Data:", selectedBranch);
      const categorySet = new Set<string>();

      if (invoiceType === 'sales') {
        console.log('sales invoice details', this.sales_invoice_details);
        const salesInvoiceDetail = this.sales_invoice_details;
        console.log('credit note salesInvoiceDetail', salesInvoiceDetail);
        so_no = this.sales_invoice_details[0]?.so_no ?? '';
        sales_invoice_date = this.sales_invoice_details[0]?.sales_invoice_date ?? '';
        si_no = this.sales_invoice_details[0]?.si_no ?? '';
        credit_note_date = (this.date);
        resultArray = [];
        totalbefortax = 0;
        totaltax = 0;

        (salesInvoiceDetail || []).forEach(item => {
          if (!(item.change_qty && item.change_qty > 0)) return;
          const qty = Number(item.change_qty);
          const unitPrice = Number(item.unit_price);
          // const amount = qty * unitPrice;
          const amount = (Number(item.change_value) - Number(item.final_discount || 0) + Number(item?.final_incentive || 0));
          const gstPercent = Number(item.gst_percentage || 0);
          let cgst = 0, sgst = 0, igst = 0;

          if (gstPercent > 0) {
            const sameState = this.gstMatch();
            if (sameState) {
              cgst = gstPercent / 2;
              sgst = gstPercent / 2;
            } else {
              igst = gstPercent;
            }
          }

          const productgstAmount = (amount * gstPercent) / 100;
          totalbefortax += amount;
          totaltax += productgstAmount;

          resultArray.push({
            id: item.product_id,
            name: item.name,
            description: item.description ?? '',
            line_document_no: item?.line_document_no ?? '',
            // quantity: qty,
            unitprice: unitPrice,
            // amount,
            quantity: qty,
            // unitprice: item.change_value / item.change_qty,
            amount: amount,
            hsn: item.hsn_no ?? '',
            unit: item.unit_name ?? '',
            gst_id: item.gst_id,
            gst_percentage: gstPercent,
            cgst,
            sgst,
            igst,
            gst_type: this.vendorBranchGstType ?? '',
            productgstAmount: productgstAmount.toFixed(2),
          });
        });
        console.log('credit note resultArray', resultArray);
        totaldiscount = 0;
        totalafterdiscount = totalbefortax;
        totalamount = totalbefortax + totaltax;
        roundedamount = totalamount;
      } else if (invoiceType === 'purchase') {
        //console.log('purchase invoice details', this.purchase_invoice_details);
        console.log('debit note details', this.debit_note_details);
        const purchaseInvoiceDetail = this.debit_note_details;
        console.log('debit note purchaseInvoiceDetail', purchaseInvoiceDetail);
        po_no = this.debit_note_details[0]?.po_no ?? '';
        purchase_invoice_date = this.debit_note_details[0]?.purchase_invoice_date ?? '';
        pi_no = this.debit_note_details[0]?.pi_no ?? '';
        debit_note_date = (this.date);
        resultArray = [];
        totalbefortax = 0;
        totaltax = 0;

        (purchaseInvoiceDetail || []).forEach(item => {
          if (!item.qty || item.qty <= 0) return;
          const qty = Number(item.qty);
          const unitPrice = Number(item.unit_price);
          // const amount = qty * unitPrice;
          const amount = Number(item.value);
          const gstPercent = Number(item.gst_percentage || 0);
          let cgst = 0, sgst = 0, igst = 0;

          if (gstPercent > 0) {
            const sameState = this.gstMatch();
            if (sameState) {
              cgst = gstPercent / 2;
              sgst = gstPercent / 2;
            } else {
              igst = gstPercent;
            }
          }
          const productgstAmount = (amount * gstPercent) / 100;
          totalbefortax += amount;
          totaltax += productgstAmount;

          resultArray.push({
            id: item.product_id,
            name: item.name,
            description: item.description ?? '',
            line_document_no: item?.line_document_no ?? '',
            // quantity: qty,
            unitprice: unitPrice,
            // amount,
            quantity: qty,
            // unitprice: item.change_value / item.change_qty,
            amount: amount,
            hsn: item.hsn_no ?? '',
            unit: item.unit_name ?? '',
            gst_id: item.gst_id,
            gst_percentage: gstPercent,
            cgst,
            sgst,
            igst,
            gst_type: this.vendorBranchGstType ?? '',
            productgstAmount: productgstAmount.toFixed(2)
          });
        });
        console.log('debit note resultArray', resultArray);

        totaldiscount = 0;
        totalafterdiscount = totalbefortax;
        totalamount = totalbefortax + totaltax;
        roundedamount = totalamount;
      }
      const allCategories = Array.from(categorySet).join('\n');
      const exportdata = {
        exportType: "pdf",
        expanded: "True",
        copy_key: copyKey,
        vendor_id: isPurchase ? this.vendor : this.customer,
        voucher_type: selectedVoucher?.voucher_type,
        customerbranchgst: (this.invoice_type === 'sales') ? this.customer_branch_gst : '',
        customerbranchname: (this.invoice_type === 'sales') ? this.customer_branch_name : '',
        customerbranchaddress: (this.invoice_type === 'sales') ? this.customer_branch_address : '',
        customerbranchaddress1: (this.invoice_type === 'sales') ? this.customer_branch_address1 : '',
        customerbranchcity: (this.invoice_type === 'sales') ? this.customer_branch_city : '',
        customerbranchpincode: (this.invoice_type === 'sales') ? this.customer_branch_pincode : '',
        customerbranchdistrict: (this.invoice_type === 'sales') ? this.customer_branch_district : '',
        customerbranchstate: (this.invoice_type === 'sales') ? this.customer_branch_state : '',
        vendorbranchgst: (this.invoice_type === 'purchase') ? this.vendor_branch_gst : '',
        vendorbranchname: (this.invoice_type === 'purchase') ? this.vendor_branch_name : '',
        vendorbranchaddress: (this.invoice_type === 'purchase') ? this.vendor_branch_address : '',
        vendorbranchaddress1: (this.invoice_type === 'purchase') ? this.vendor_branch_address1 : '',
        vendorbranchcity: (this.invoice_type === 'purchase') ? this.vendor_branch_city : '',
        vendorbranchpincode: (this.invoice_type === 'purchase') ? this.vendor_branch_pincode : '',
        vendorbranchdistrict: (this.invoice_type === 'purchase') ? this.vendor_branch_district : '',
        vendorbranchemail: (this.invoice_type === 'purchase') ? this.vendor_branch_email : '',
        vendorbranchphone: (this.invoice_type === 'purchase') ? this.vendor_branch_phone : '',
        companyname: this.company_name ?? '',
        branchaddress: branch_billing_address,
        branchphone: branch_billing_phone,
        branchphone1: branch_billing_phone1,
        branchemail: branch_email,
        branchfax: branch_fax,
        branchwebsite: branch_website,
        companygstno: this.company_gstno ?? '',
        companypan: this.company_pan ?? '',
        companylogo: this.company_logo ?? '',
        companysignature: this.company_signature ?? '',
        companycin: this.company_cin ?? '',
        invoiceno: this.document_no ?? '',
        isposted: 0,
        data: resultArray,
        totalbefortax: parseFloat(totalbefortax.toFixed(2)),
        totaldiscount: parseFloat(totaldiscount.toFixed(2)),
        totalafterdiscount: parseFloat(totalafterdiscount.toFixed(2)),
        totaltax: parseFloat(totaltax.toFixed(2)),
        roundedamount: parseFloat(roundedamount.toFixed(2)),
        totalamount: totalamount.toFixed(2),
        vouchernumber: this.voucherNo ?? '',
        doc_no,
        so_no,
        si_no,
        po_no,
        pi_no,
        // so_date,
        // start_date,
        // end_date,
        date: this.formatDateForPdf(this.issue_date),
        so_date: this.formatDateForPdf(so_date),
        //po_date: this.formatDateForPdf(po_date),
        sales_invoice_date: this.formatDateForPdf(sales_invoice_date),
        purchase_invoice_date: this.formatDateForPdf(purchase_invoice_date),
        credit_note_date: this.formatDateForPdf(credit_note_date),
        debit_note_date: this.formatDateForPdf(debit_note_date),
        start_date: this.formatDateForPdf(start_date),
        end_date: this.formatDateForPdf(end_date),
        branch_gst: branch_gst,
        category_name: allCategories,
        gst_type: isCreditNote ? this.sales_invoice_details?.[0]?.customer_branch_gst_type ?? '' : this.vendorBranchGstType,
        invoice_type: this.invoice_type ?? '',
      };
      console.log("Voucher Type:", this.voucherType);
      console.log("Vendor ID:", this.vendor);
      console.log("Customer ID:", this.customer);
      console.log('Export Data Payload:', exportdata);
      // return
      this.apiService.voucherpostingexport(exportdata).subscribe({
        next: (response) => {
          const downloadUrl = response[0];
          const filename = downloadUrl.substring(downloadUrl.lastIndexOf('/') + 1);
          const downloadLink = document.createElement('a');
          downloadLink.href = downloadUrl;
          downloadLink.download = filename;
          downloadLink.target = '_blank';
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        },
        error: (error) => console.error('Error sending data:', error),
      });

    } catch (error) {
      console.error('Error in convertToPdf():', error);
    }
  }
  formatDateForPdf = (date: any) => {
    if (!date) return '';
    const d = new Date(date);
    if (isNaN(d.getTime())) return date;
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = String(d.getFullYear());
    return `${day}-${month}-${year}`;
  };
  documentDetails(voucherData:any) {
    const postData = {
      voucher_type: this.voucher_type,
      invoice_type: this.invoice_type,
      invoice_id: this.purchaseInvoice ?? this.salesInvoice,
      invoice_branch: this.branch
    };
    this.apiService.documentDataDetails(postData).subscribe(
      (response) => {
        this.documentdetails = response[0].sales_purchase_details;

        console.log('documents details', this.documentdetails);
        if (this.data.id) {
          this.fetchSalesInvoiceDetails(this.salesInvoice,voucherData);
        }
      },
      (error) => {
        console.error('Error fetching documents:', error);
      }
    );
  }
  fetchGrnDetails() {
    console.log("Invoice Type:", this.invoice_type);
    console.log("Vouchers:", this.vouchers);
    const selectedVoucher = this.vouchers.find(voucher => voucher.name === this.invoice_type);
    console.log("Selected Voucher:", selectedVoucher);
    const postData = {
      voucher_type: this.voucher_type,
      invoice_id: this.purchaseInvoice ?? this.salesInvoice,
      invoice_type: this.invoice_type,
      invoice_voucher_id: selectedVoucher?.id,
      document_id: this.document,
      profit_cost_id: this.profit_cost_id
    };
    console.log("Post Data:", postData);
    this.apiService.itemDetails(postData).subscribe(
      (response) => {
        this.debit_note_details = response;
        console.log('item details', response);
        this.vendors = this.debit_note_details[0].vendor_name;
        this.vendor_branchs = this.debit_note_details[0].vendor_branch_name;
        this.vendor_branch_name = this.debit_note_details[0].vendor_branch_name;
        // this.cutomer_branch_ledger_id = this.credit_note_details[0].customer_branch_ledger_id;
        // this.cutomer_branch_ledger_name = this.credit_note_details[0].customer_branch_ledger_name;
        this.vendor_address = this.debit_note_details[0].vendor_address;
        this.vendor_email = this.debit_note_details[0].vendor_email;
        this.vendor_pan = this.debit_note_details[0].vendor_pan;
        this.vendor_branchs = this.debit_note_details[0].vendor_branch_name;
        this.vendor_branch_gst = this.debit_note_details[0].vendor_branch_gst;
        this.vendor_branch_address = this.debit_note_details[0].vendor_branch_address;
        this.vendor_branch_address1 = this.debit_note_details[0].vendor_branch_address1;
        this.vendor_branch_city = this.debit_note_details[0].vendor_branch_city;
        this.vendor_branch_district = this.debit_note_details[0].vendor_branch_district;
        this.vendor_branch_pincode = this.debit_note_details[0].vendor_branch_pincode;
        //this.vendor_branch_state = this.debit_note_details[0].vendor_branch_state;
        this.vendor_phone = this.debit_note_details[0].vendor_phone;
        this.unit_name = this.debit_note_details[0].unit_name;
        this.invoice_date = this.debit_note_details[0].purchase_invoice_date;
        this.vendorBranchGstType = this.debit_note_details[0].vendor_branch_gst_type;
        this.vendorbranchledger(this.debit_note_details[0].vendor_branch_id, this.branch);
        console.log('vendors', this.vendors);
        console.log('vendor branch', this.vendor_branchs);
        console.log('sales invoice details', this.sales_invoice_details);
        // console.log('customer branch ledger', this.cutomer_branch_ledger_id);
        // console.log('customer branch ledger name ', this.cutomer_branch_ledger_name);
      },
      (error) => {
        console.error('Error fetching item details:', error);
      }
    );
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
